import { Box, Card, CardContent, Grid, Skeleton, Stack, Divider } from '@mui/material';
import { Container } from '../../../components/container';

export const ClusterInstallationDetailsSkeleton = () => (
  <Container>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, gap: 2 }}>
      <Skeleton variant="circular" width={40} height={40} />
      <Skeleton variant="text" sx={{ fontSize: '2.125rem' }} width="30%" />
    </Box>

    <Box sx={{ mt: 3 }}>
      <Grid container spacing={3}>
        {[...Array(2)].map((_, index) => (
          <Grid key={index} size={{ xs: 12, md: 6 }}>
            <Card
              sx={{
                height: '100%',
                borderRadius: 3,
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
                  <Skeleton variant="text" sx={{ fontSize: '1.25rem' }} width="60%" />
                </Box>

                <Stack spacing={3}>
                  <Box>
                    <Skeleton variant="text" width="30%" sx={{ mb: 0.5 }} />
                    <Skeleton variant="rectangular" width="70%" height={28} sx={{ borderRadius: 0.5 }} />
                  </Box>

                  <Box>
                    <Skeleton variant="text" width="40%" sx={{ mb: 0.5 }} />
                    <Skeleton variant="rectangular" width={100} height={24} sx={{ borderRadius: 2 }} />
                  </Box>

                  <Box>
                    <Skeleton variant="text" width="35%" sx={{ mb: 0.5 }} />
                    <Skeleton variant="rectangular" width={100} height={24} sx={{ borderRadius: 2 }} />
                  </Box>

                  <Divider />

                  <Box>
                    <Skeleton variant="text" width="50%" sx={{ mb: 1 }} />
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                      {[...Array(4)].map((_, i) => (
                        <Skeleton key={i} variant="rectangular" width={140} height={24} sx={{ borderRadius: 1 }} />
                      ))}
                    </Stack>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Container>
);
